<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.QuotationClient')"
    width="640px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view fcl-extra-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
        <el-button no="refresh" @click="refresh">{{ $t('Pricing.Refresh') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.ClientName')">
                <el-select
                  ref="clientName"
                  v-model="price.name"
                  no="name"
                  :allow-create="true"
                  :clearable="true"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="similarClientFilter"
                  @change="nameChange"
                >
                  <el-option
                    v-for="(item,index) in similarClients"
                    :key="index"
                    :label="`[${item.officeCode}]${item.name}`"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Contact')">
                <el-input
                  ref="contact"
                  v-model="price.contact"
                  no="contact"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Phone')">
                <el-input
                  ref="phone"
                  v-model="price.phone"
                  no="phone"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Fax')">
                <el-input
                  v-model="price.fax"
                  no="fax"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Email')">
                <el-input
                  v-model="price.email"
                  no="email"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Owner')">
                <cargo-user-select
                  no="ownerId"
                  :method-params="{category:'role',shape:'sales'}"
                  :default-value="price.ownerId||''"
                  @change="p=>{price.ownerId=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.Address')">
                <el-input v-model="price.address" no="address" type="textarea" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <el-input v-model="price.remarks" no="remarks" type="textarea" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { getLoading } from '@/utils/utilBaseElement'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { isClientExist, querySimilarClients, saveQuotationClient } from '@/api/sales/quotationClient'
import StrUtils from '@/utils/StrUtils'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { deepClone } from '@/utils'

export default {
  name: 'QuotationClientPopup',
  components: { CargoUserSelect, CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    quotationClient: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      similarClients: [],
      chooseClient: null,
      price: {}
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  mounted() {
    this.price = deepClone(this.quotationClient)
  },
  methods: {
    onSubmit() {
      const client = this.price
      if (StrUtils.isEmpty(client.uuid)) {
        client.createdBy = this.$store.getters.userId
        client.dateCreated = new Date()
        client.branchId = this.$store.getters.currentOfficeId
      }
      if (!client.ownerId) {
        client.ownerId = client.createdBy
      }
      if (StrUtils.isEmpty(client.name)) {
        this.$refs['clientName'].focus()
        return
      }
      if (StrUtils.isEmpty(client.contact)) {
        this.$refs['contact'].focus()
        return
      }
      if (StrUtils.isEmpty(client.phone)) {
        this.$refs['phone'].focus()
        return
      }
      const isAdmin = this.$store.getters.isAdmin
      if (isAdmin) {
        this.save()
        return
      }
      if (this.chooseClient instanceof Object) {
        if (SalesUtil.getInstance().juniorSaleMap[this.chooseClient.ownerId]) {
          this.$message.warning(this.$t('Pricing.ClientExist'))
          return
        }
      }
      isClientExist({ name: client.name, uuid: client.uuid }).then(res => {
        if (res.data) {
          this.$message.warning(this.$t('Pricing.ClientExist'))
          return
        }
        this.save()
      })
    },
    save() {
      this.fullscreenLoading = getLoading()
      this.price.customerStatusCode = '0'
      this.price.firstMeetDate = new Date()
      saveQuotationClient({ quotationClient: this.price }).then((res) => {
        this.fullscreenLoading.close()
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.$emit('callback', StrUtils.isEmpty(this.price.uuid), res.data)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onCancel() {
      this.$emit('close')
    },
    similarClientFilter(query) {
      setTimeout(() => {
        querySimilarClients({ name: query }).then(res => {
          this.similarClients = res.data
        })
      }, 200)
    },
    nameChange(p) {
      if (p instanceof Object) {
        this.price.name = `[${p.officeCode}]${p.name}`
      }
      this.chooseClient = p
    },
    refresh() {
      this.price = this.quotationClient
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .fcl-extra-form{
    .el-radio-group{
      margin-bottom: 8px;
      margin-top: 8px;
    }
    .el-radio{
      margin-right: 10px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
